

























































import Vue, { PropType } from 'vue';
import { FirestoreDate } from '@/modules/firestore';
import { MessageTypes, Message } from '@/modules/contact/message';

import {
  PublicBuyer,
  PublicBuyerCompany,
  PublicExhibitor,
  PublicExhibitorCompany,
  ContactData,
  calender,
} from 'mostra';

interface DisplayMessage {
  date: FirestoreDate;
  messages: Message[];
}

export default Vue.extend({
  name: 'GChatMessageArea',
  props: {
    displayMessages: { type: Array as PropType<DisplayMessage[]>, default: () => [] },
    contact: { type: Object as PropType<ContactData>, required: true },
    exhibitor: { type: Object as PropType<PublicExhibitor>, required: true },
    buyer: { type: Object as PropType<PublicBuyer>, required: true },
    companyExhibitor: { type: Object as PropType<PublicExhibitorCompany>, required: true },
    companyBuyer: { type: Object as PropType<PublicBuyerCompany>, required: true },
    avatarExhibitor: { type: String as PropType<String>, default: null },
    avatarBuyer: { type: String as PropType<String>, default: null },
    ownerID: { type: String as PropType<String>, default: '' },
  },
  // data() {
  //   return {
  //   };
  // },
  computed: {
    messageTypes() {
      return MessageTypes;
    },
  },
  methods: {
    checkAsRead(sentDate: FirestoreDate): boolean {
      const sentDt = calender.toDate(sentDate).getTime();
      const asReadDateTimes = this.contact.asReadDateTimes;
      const uid = this.$auth.uid;
      const otherAsReadsDateTimes = asReadDateTimes.filter(
        (val) => val.uid !== uid,
      );
      let seen = false;
      otherAsReadsDateTimes.forEach((val) => {
        const seenDt = val.dt;
        if (seenDt > sentDt) {
          seen = true;
        }
      });
      return seen;
    },
  },
});
